import React from "react";

/**
 * Flat bordered card: icon, title, one line of body.
 *
 * Border rather than shadow (flat style), and no fixed height — Kazakh and
 * Russian strings run 15-30% longer than English, so cards must grow.
 */
export default function FeatureCard({ Icon, title, body, index = 0 }) {
  return (
    <div
      className="landing-reveal flex h-full flex-col rounded-xl border border-line bg-white p-6"
      data-reveal-index={index}
    >
      {Icon && (
        <span className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-lg bg-gray-landing">
          <Icon className="h-5 w-5 text-primary" aria-hidden="true" />
        </span>
      )}
      <h3 className="text-xl font-semibold leading-snug text-black-landing">
        {title}
      </h3>
      {body && <p className="mt-2 leading-relaxed text-muted">{body}</p>}
    </div>
  );
}
